module.exports = __webpack_public_path__ + "static/media/ibd_arm3.c5682da4.png";